import { render } from "./BeginningAzureDevOps.vue?vue&type=template&id=3de971c6&scoped=true"
import script from "./BeginningAzureDevOps.vue?vue&type=script&lang=js"
export * from "./BeginningAzureDevOps.vue?vue&type=script&lang=js"

import "./BeginningAzureDevOps.vue?vue&type=style&index=0&id=3de971c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de971c6"]])

export default __exports__